import {
  CREATE_PRODUCT_PAYOUT,
  CREATE_PRODUCT_COLLECTION,
  PRODUCT_ASYNC_START,
  PRODUCT_ASYNC_END,
  PRODUCT_LOG_ERROR,
  FETCH_PRODUCTS,
  FETCH_PRODUCT_DETAILS,
  RESET_PRODUCT_TRANSACTIONS,
  PRODUCT_FETCH_CLEAR,
  FETCH_PRODUCT_OFFERINGS,
  FETCH_PRODUCT_FIELDS,
  FETCH_PRODUCT_KEYS,
  EDIT_PRODUCT_COLLECTION,
} from '../types';
import Products from 'services/products';
import moment from 'moment';
import { toast } from 'react-toastify';
import { showToast } from './toast';
import { AnalyticsLogStatus } from 'libs';
import FirebaseAnalytics from 'libs/analytics';

export const fetchProducts = (filters, type) => async (dispatch, getState) => {
  dispatch({
    type: PRODUCT_ASYNC_START,
    subType: 'products',
  });
  try {
    const {
      common: { user },
    } = getState();

    let productsArray = [];
    let meta = null;

    const {
      data: { list, ...extra },
    } = await Products.fetch(user?.merchantId, filters);

    productsArray = list;
    meta = extra;

    dispatch({
      type: FETCH_PRODUCTS,
      payload: { data: list, meta },
      subType: 'products',
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_ASYNC_END,
      subType: 'products',
    });
    dispatch(
      showToast(
        'error',
        error?.response?.data?.message || 'Something went wrong. Try again',
      ),
    );
  }
};

export const fetchProductDetails = (code) => async (dispatch) => {
  dispatch({
    type: PRODUCT_ASYNC_START,
    subType: 'products',
  });
  const momentFormant = 'YYYY-MM-DD';
  const transactionsParams = {
    startDate: moment().startOf('year').format(momentFormant),
    endDate: moment().format(momentFormant),
    limit: 10,
    page: 0,
  };
  try {
    const { data: details } = await Products.fetchDetails(code);
    dispatch({
      type: FETCH_PRODUCT_DETAILS,
      payload: details,
      subType: 'products',
    });
    dispatch(fetchProductTransactions(code, transactionsParams));
  } catch (error) {
    dispatch(
      showToast(
        'error',
        error?.response?.data?.message || 'Something went wrong. Try again',
      ),
    );
  }
};

export const fetchProductKeys = (code) => async (dispatch) => {
  dispatch({
    type: PRODUCT_ASYNC_START,
    subType: 'products',
  });

  try {
    const { data: details } = await Products.fetchProductKeys(code);
    dispatch({
      type: FETCH_PRODUCT_KEYS,
      payload: details,
      subType: 'products',
    });
  } catch (error) {
    dispatch(
      showToast(
        'error',
        error?.response?.data?.message || 'Something went wrong. Try again',
      ),
    );
  }
};

export const fetchProductFields = (code) => async (dispatch) => {
  dispatch({
    type: PRODUCT_ASYNC_START,
    subType: 'products',
  });

  try {
    const { data: details } = await Products.fetchProductFields(code);
    dispatch({
      type: FETCH_PRODUCT_FIELDS,
      payload: details,
      subType: 'products',
    });
  } catch (error) {
    dispatch(
      showToast(
        'error',
        error?.response?.data?.message || 'Something went wrong. Try again',
      ),
    );
  }
};

export const clearFetchedProduct = (subType) => async (dispatch) => {
  dispatch({
    type: PRODUCT_FETCH_CLEAR,
    subType,
  });
};

export const resetProductTransactions = () => async (dispatch) => {
  dispatch({
    type: RESET_PRODUCT_TRANSACTIONS,
    subType: 'transactions',
  });
};

export const fetchProductTransactions =
  (code, params) => async (dispatch, getState) => {
    dispatch({
      type: PRODUCT_ASYNC_START,
      subType: 'transactions',
    });

    const {
      common: { user },
    } = getState();
    const transactionsParams = {
      ...params,
      sortOrder: 'DESC',
      sortBy: 'createdAt',
    };
    try {
      const {
        data: { list, ...meta },
      } = await Products.fetchTransactions(code, transactionsParams);
      dispatch({
        type: FETCH_PRODUCTS,
        payload: { data: list, meta },
        subType: 'transactions',
      });
    } catch (error) {
      dispatch({
        type: PRODUCT_ASYNC_END,
        subType: 'transactions',
      });
      dispatch(
        showToast(
          'error',
          error?.response?.data?.message || 'Something went wrong. Try again',
        ),
      );
    }
  };

export const createPayout = (body) => (dispatch) => {
  dispatch({
    type: PRODUCT_ASYNC_START,
  });
  return Products.createPayout(body)
    .then((data) => {
      const { status } = data;
      if (status === 200) {
        return dispatch({
          type: CREATE_PRODUCT_PAYOUT,
          payload: data,
        });
      }
      dispatch({
        type: PRODUCT_LOG_ERROR,
      });
      return null;
    })
    .catch(({ response }) => {
      if (response !== undefined && response.data.message) {
        dispatch({
          type: PRODUCT_LOG_ERROR,
          error: response.data.message,
        });
        return null;
      }
      dispatch({
        type: PRODUCT_LOG_ERROR,
      });
      return toast.error(response?.data?.message || 'Something went wrong');
    });
};

export const createCollection = (body) => (dispatch) => {
  dispatch({
    type: PRODUCT_ASYNC_START,
    subType: 'products',
  });

  return Products.createProduct(body)
    .then((data) => {
      const { status } = data;
      if (status === true) {
        return dispatch({
          type: CREATE_PRODUCT_COLLECTION,
          subType: 'products',
          payload: data,
        });
      }
      FirebaseAnalytics.logWithValue('product_successful', {
        STATUS: AnalyticsLogStatus.SUCCESS,
      });
      dispatch({
        type: PRODUCT_LOG_ERROR,
        subType: 'products',
      });
      return null;
    })
    .catch(({ response }) => {
      FirebaseAnalytics.logWithValue('product_successful', {
        STATUS: AnalyticsLogStatus.FAILED,
      });
      if (response !== undefined && response.data.message) {
        dispatch({
          type: PRODUCT_LOG_ERROR,
          subType: 'products',
          error: response.data.message,
        });
        dispatch(
          showToast(
            'error',
            response?.data?.message || 'Something went wrong. Try again',
          ),
        );
        return null;
      }
      dispatch({
        type: PRODUCT_LOG_ERROR,
        subType: 'products',
      });
    });
};

export const editCollection = (productId, body) => (dispatch) => {
  dispatch({
    type: PRODUCT_ASYNC_START,
    subType: 'products',
  });
  return Products.editProduct(productId, body)
    .then((data) => {
      const { status } = data;
      if (status === true) {
        return dispatch({
          type: EDIT_PRODUCT_COLLECTION,
          subType: 'products',
          payload: data,
        });
      }
      dispatch({
        type: PRODUCT_LOG_ERROR,
        subType: 'products',
      });
      return null;
    })
    .catch(({ response }) => {
      if (response !== undefined && response.data.message) {
        dispatch({
          type: PRODUCT_LOG_ERROR,
          subType: 'products',
          error: response.data.message,
        });
        dispatch(
          showToast(
            'error',
            response?.data?.message || 'Something went wrong. Try again',
          ),
        );
        return null;
      }
      dispatch({
        type: PRODUCT_LOG_ERROR,
        subType: 'products',
      });
    });
};

export const fetchProductOfferings = () => async (dispatch) => {
  dispatch({
    type: PRODUCT_ASYNC_START,
    subType: 'products',
  });

  try {
    const { data: offerings } = await Products.fetchOfferings();
    dispatch({
      type: FETCH_PRODUCT_OFFERINGS,
      payload: offerings.list,
      subType: 'products',
    });
  } catch (error) {
    return toast.error(
      error?.response?.data?.message || 'Something went wrong',
    );
  }
};
